import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Tab, Tabs, Typography, Avatar } from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../../utilities/FormPageHeader';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import Personal from './tabs/Personal';

import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import FuseNavigation from '@fuse/core/FuseNavigation';
import { styled } from '@mui/material/styles';
import FusePageCarded from '@fuse/core/FusePageCarded';
import TrainerNavigation from './TrainerNavigation';
import Organization from './tabs/Organization';
import Documents from './tabs/Documents';
import TrainingEduction from './tabs/TrainingEduction';
import Attendance from './tabs/Attendance';
import Asset from './tabs/Asset';
import moment from 'moment';



const Root = styled(FusePageCarded)(({ theme }) => ({
    '& .FusePageCarded-header': {},
    '& .FusePageCarded-wrapper': {},
    '& .FusePageCarded-leftSidebar': {},
    '& .description': {
        fontSize: 20,
        marginBottom: 40,
    },

    '& .avatar': {
        background: theme.palette.background.default,
        transition: theme.transitions.create('all', {
            duration: theme.transitions.duration.shortest,
            easing: theme.transitions.easing.easeInOut,
        }),
        bottom: 0,
        '& > img': {
            borderRadius: '50%',
        },
    },
}));

const TrainersForm = () => {

    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;

    const [tabValue, setTabValue] = useState(0);
    const params = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [validError, setValidError] = useState({});
    const [checkSubmit, setCheckSubmit] = useState(false);
    const [hideDelete, setHideDelete] = useState(true);
    const [saveDisable, setSaveDisable] = useState(true);
    const [document, setDocument] = useState([]);
    const [documentString, setDocumentString] = useState([]);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);
    const [personalInfoEditData, setPersonalInfoEditData] = useState();
    const [currentAddressEditData, setCurrentAddressEditData] = useState();
    const [homeTownAddressEditData, setHomeTownAddressEditData] = useState();
    const [employeeRecordEditData, setEmployeeRecordEditData] = useState();
    const [passportInfoEditData, setPassportInfoEditData] = useState();
    const [familyInfoEditData, setFamilyInfoEditData] = useState();
    const [emergencyContactEditData, setEmergencyContactEditData] = useState();
    const [legelNomineeEditData, setLegelNomineeEditData] = useState();
    const [bankInfoEditData, setBankInfoEditData] = useState();
    // const [showBackButton, setShowBackButton] = useState(true);
    const [sameAddCheckBox , setSameAddCheckBox] = useState(false);
    const [personalInfo, setPersonalInfo] = useState({
        trainersId: Number,
        profilePic:"",
        displayName: "",
        empFirstName: "",
        empMiddleName: "",
        empLastName: "",
        nationality: "",
        religion: "",
        title: "",
        dateOfBirth: null,
        birthPlace: "",
        martialStatus: "",
        gender: "",
        email: "",
    });
    const [currentAddress, setCurrentAddress] = useState({
        country: "",
        state: "",
        city: "",
        zipCode: "",
        address1: "",
        phone: "",
        extension: "",
        mobile: "",
        email: "",
    });
    const [homeTownAddress, setHomeTownAddress] = useState({
        country: "",
        state: "",
        city: "",
        zipCode: "",
        address1: "",
        phone: "",
        extension: "",
        mobile: "",
        email: "",
    });
    const [employeeRecord, setEmployeeRecord] = useState({
        joiningDate: null,
        seniorityDate: null,
        employment: "",
        designation: "",
        department: "",
        reportingManager: "",
        role: "",
        contractType: "",
    });
    const [passportInfo, setPassportInfo] = useState({
        namePassport: "",
        passportNumber: "",
        nationality: "",
        placeOfIssue: "",
        issueDate: null,
        expiryDate: null,
        issuedBy: "",
        issueIn: "",
        documentUpload: [],
    });
    const [familyInfo, setFamilyInfo] = useState({
        fatherName: "",
        fatherEmail: "",
        fatherContact: "",
        fatherAddress: {
            address1: ""
        },
        motherName: "",
        motherEmail: "",
        motherContact: "",
        motherAddress: {
            address1: ""
        },
        civilStatus: "",
        spouseName: "",
        spouseNationality: "",
        noOfChildren: "",
        spouseContact: "",
        spouseEmail: "",
        spouseHomeAddress: {
            address1: ""
        },
    });
    const [emergencyContact, setEmergencyContact] = useState({
        name: "",
        relation: "",
        mobileNumber: "",
        address: {
            address1: ""
        },
        telephone: "",
        email: ""
    });
    const [legelNominee, setLegelNominee] = useState({
        name: "",
        relation: "",
        mobileNumber: "",
        address: {
            address1: ""
        },
        telephone: "",
        email: ""
    });
    const [bankInfo, setBankInfo] = useState({
        bankName: "",
        accountName: "",
        accountNumber: "",
        location: "",
        iban: "",
        otherInfo: ""
    })



    /*------------------------------ handle Change------------------------------*/


    const handlePersonalInfoChange = (event, key) => {
        if (key === "dateOfBirth") {
            setPersonalInfo({ ...personalInfo, [key]: moment(event).format('YYYY-MM-DD') });
        } else {
            setPersonalInfo({ ...personalInfo, [event.target.name]: event.target.value });
        }
    }
    const handleCurrentAddressChange = (event) => {
        setCurrentAddress({ ...currentAddress, [event.target.name]: event.target.value });
    }
    const handleHomeTownAddressChange = (event) => {
        setHomeTownAddress({ ...homeTownAddress, [event.target.name]: event.target.value });
    }
    const handleEmployeeRecordChange = (event, key) => {
        if (key) {
            if (key === "joiningDate") {
                setEmployeeRecord({ ...employeeRecord, [key]: moment(event).format('YYYY-MM-DD') });
            } else {
                setEmployeeRecord({ ...employeeRecord, [key]: moment(event).format('YYYY-MM-DD') });
            }
        } else {
            setEmployeeRecord({ ...employeeRecord, [event.target.name]: event.target.value });
        }
    }
    const handlePassPortInfoChange = (event, key) => {
        if (key) {
            if (key === "issueDate") {
                setPassportInfo({ ...passportInfo, [key]: moment(event).format('YYYY-MM-DD') });
            } else {
                setPassportInfo({ ...passportInfo, [key]: moment(event).format('YYYY-MM-DD') });
            }
        } else {
            setPassportInfo({ ...passportInfo, [event.target.name]: event.target.value });
        }
    }
    const handleFamilyInfoChange = (event, key) => {
        if (key === "fatherAddress") {
            setFamilyInfo(prevValue => ({
                ...prevValue,
                fatherAddress: { ...prevValue.fatherAddress, [event.target.name]: event.target.value }
            }));
        } else if (key === "motherAddress") {
            setFamilyInfo(prevValue => ({
                ...prevValue,
                motherAddress: { ...prevValue.motherAddress, [event.target.name]: event.target.value }
            }));
        } else if (key === "spouseHomeAddress") {
            setFamilyInfo(prevValue => ({
                ...prevValue,
                spouseHomeAddress: { ...prevValue.spouseHomeAddress, [event.target.name]: event.target.value }
            }));
        } else {
            setFamilyInfo({ ...familyInfo, [event.target.name]: event.target.value });
        }
    }
    const handleEmergencyContactChange = (event, key) => {
        if (key === "emergencyContact") {
            setEmergencyContact(prevValue => ({
                ...prevValue,
                address: { ...prevValue.address, [event.target.name]: event.target.value }
            }));
        } else {
            setEmergencyContact({ ...emergencyContact, [event.target.name]: event.target.value });
        }
    }
    const handleLegalNomineeChange = (event, key) => {
        if (key === "legelNominee") {
            setLegelNominee(prevValue => ({
                ...prevValue,
                address: { ...prevValue.address, [event.target.name]: event.target.value }
            }));
        } else {
            setLegelNominee({ ...legelNominee, [event.target.name]: event.target.value });
        }
    }
    const handleBankInfoChange = (event) => {
        setBankInfo({ ...bankInfo, [event.target.name]: event.target.value });
    }

    const handleDocumentChange = (e) => {
        const file = e.target.files[0];
        setDocument([...document, file])

        var reader = new FileReader();
        reader.onload = function (upload) {
            setPassportInfo(prevValue => ({
                ...prevValue,
                documentUpload: [...prevValue.documentUpload, upload.target.result]
            }));
        };
        reader.readAsDataURL(file);
    }

    const handleCancel = () => {
        navigate('/trainersList');
    }

    /*------------------------------ handle Submit------------------------------*/

    const handleSubmit = async () => {
        setCheckSubmit(true);
        const model = {
            ...personalInfo,
            currentAddress: currentAddress,
            homeTownAddress: homeTownAddress,
            ...employeeRecord,
            passportInfo: passportInfo,
            familyInfo: familyInfo,
            emergencyInfo: emergencyContact,
            legelNominee: legelNominee,
            bankInfo: bankInfo
        }
        const errorValue = Object.values(validError).filter((item) => item !== undefined);
        try {
            if (params.id) {
                if (errorValue.length === 0) {
                    await OAuthService.updateData(url, params.id, model);
                    setSuccessMsg("Data Updated Successfully");
                    setSnackState(true);
                    setTimeout(() => { navigate('/employee'); }, 800);
                }
            } else {
                if (errorValue.length === 0) {
                    const res = await OAuthService.addData(url, model);
                    if (res.status === 201) {
                        setSuccessMsg("Data saved Successfully");
                        setSnackState(true);
                        setTimeout(() => { navigate('/employee'); }, 800);
                    }
                }

            }

        } catch (error) {
            setError(error.message)
            return;
        }
    }

    const getEmployee = async () => {
        try {
            if (params.id) {
                const result = await OAuthService.getEditData(url, params.id);
                const employee = result?.data;
                const personalRecord = {
                    employeeId: employee.employeeId,
                    displayName: employee.displayName,
                    empFirstName: employee.empFirstName,
                    empMiddleName: employee.empMiddleName,
                    empLastName: employee.empLastName,
                    nationality: employee.nationality,
                    religion: employee.religion,
                    title: employee.title,
                    dateOfBirth: employee.dateOfBirth,
                    birthPlace: employee.birthPlace,
                    martialStatus: employee.martialStatus,
                    gender: employee.gender,
                    email: employee.email,
                }
                const employeeRecord = {
                    joiningDate: employee.joiningDate,
                    seniorityDate: employee.seniorityDate,
                    employment: employee.employment,
                    designation: employee.designation,
                    department: employee.department,
                    reportingManager: employee.reportingManager,
                    role: employee.role,
                    contractType: employee.contractType,
                }
                setPersonalInfo(personalRecord);
                setPersonalInfoEditData(personalRecord);
                setCurrentAddress(employee.currentAddress || []);
                setCurrentAddressEditData(employee.currentAddress || []);
                setHomeTownAddress(employee.homeTownAddress);
                setHomeTownAddressEditData(employee.homeTownAddress);
                setEmployeeRecord(employeeRecord);
                setEmployeeRecordEditData(employeeRecord);
                setEmergencyContact(employee.emergencyInfo);
                setEmergencyContactEditData(employee.emergencyInfo);
                setLegelNominee(employee.legelNominee);
                setLegelNomineeEditData(employee.legelNominee);
                setFamilyInfo(employee.familyInfo);
                setFamilyInfoEditData(employee.familyInfo);
                setBankInfo(employee?.bankInfo);
                setBankInfoEditData(employee?.bankInfo);
                setPassportInfo(employee?.passportInfo);
                setPassportInfoEditData(employee?.passportInfo);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const handleDelete = async () => {
        setCheckSubmit(true);
        try {
            if (params.id) {
                await OAuthService.deleteData(url, params.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                setTimeout(() => { navigate('/employee') }, 800);
            }
        } catch (error) {
            console.log("error", error);
            setError(error.message);
        }
    }

    useEffect(() => {
        if (params.id) {
            getEmployee();
            setHideDelete(false)
        }
    }, [])

    useEffect(() => {
        if (personalInfo.employeeId && personalInfo.title && personalInfo.empFirstName && personalInfo.empMiddleName && personalInfo.empLastName && personalInfo.email && personalInfo.gender && employeeRecord.department && employeeRecord.designation && personalInfo.dateOfBirt
            ) {
            setSaveDisable(true);
            if (personalInfoEditData) {
                if (JSON.stringify(personalInfo) !== JSON.stringify(personalInfoEditData) || JSON.stringify(currentAddress) !== JSON.stringify(currentAddressEditData) || JSON.stringify(homeTownAddress) !== JSON.stringify(homeTownAddressEditData) ||
                    JSON.stringify(employeeRecord) !== JSON.stringify(employeeRecordEditData) || JSON.stringify(passportInfo) !== JSON.stringify(passportInfoEditData) || JSON.stringify(familyInfo) !== JSON.stringify(familyInfoEditData) ||
                    JSON.stringify(emergencyContact) !== JSON.stringify(emergencyContactEditData) || JSON.stringify(legelNominee) !== JSON.stringify(legelNomineeEditData) || JSON.stringify(bankInfo) !== JSON.stringify(bankInfoEditData)) {
                    setSaveDisable(false);
                } else {
                    setSaveDisable(true);
                }
            }
            else {
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    }, [personalInfo, currentAddress, homeTownAddress, employeeRecord, passportInfo, familyInfo, emergencyContact, legelNominee, bankInfo]);

    useEffect(() => {
     if(JSON.stringify(currentAddress) ===  JSON.stringify(homeTownAddress)){
        setSameAddCheckBox(true)
     }else{
        setSameAddCheckBox(false)
     }
    }, [currentAddress,homeTownAddress])
    




    return (
        <div className="w-full h-full overflow-y-scroll">
            <FormPageHeader
                componentName="Trainers"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={params.id ? "Update Trainer" : "Add Trainer"}
                BreadcrumbText={params.id ? `Update Trainer ${personalInfo.displayName}` : "Add Trainer"}
                parentBreadcrumbData={[{ pageName: 'Trainers List', pageLink: '/trainersList' }]}
                error={error}
                handleCancel={handleCancel}
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                saveDisable={saveDisable}
                sidebar={true}
            />


            <Root sx={{ minHeight: 'calc(100% - 140px)' }}

                header={
                    <div className=" py-12 px-4 md:px-12 w-full">
                        <IconButton
                            onClick={(ev) => setLeftSidebarOpen(!leftSidebarOpen)}
                            aria-label="toggle left sidebar"
                            size="large"
                        >
                            <FuseSvgIcon>heroicons-outline:view-list</FuseSvgIcon>
                        </IconButton>
                    </div>
                }
                content={
                    <div className="p-16 md:p-24 min-w-full min-h-full flex flex-auto flex-col">
                        <div className='bg-[#2a2e32] sticky top-0 z-[100]'>

                            <Tabs
                                value={tabValue}
                                onChange={(e, newValue) => setTabValue(newValue)}
                                // onChange={handleTabChange}
                                indicatorColor="secondary"
                                sx={{ color: "yellow" }}
                                variant="scrollable"
                                scrollButtons="auto"
                                classes={{ root: 'w-full h-64 border-b-1' }}
                            >
                                <Tab value={0} className="h-64" label="Personal" />
                                {/* <Tab value={1} className="h-64" label="Organization" /> */}
                                <Tab value={2} className="h-64" label="Documents" />
                                {/* <Tab value={3} className="h-64" label="Forms" /> */}
                                {/* <Tab value={4} className="h-64" label="Payroll" /> */}
                                {params.id && <Tab value={5} className="h-64" label="Attendance" />}
                                {params.id && <Tab value={6} className="h-64" label="Asset" />}
                                {/* <Tab value={7} className="h-64" label="Family" /> */}
                                {/* <Tab value={8} className="h-64" label="Training & Education" /> */}
                            </Tabs>
                        </div>

                        <div className="p-16 sm:p-24">
                            <div className={tabValue !== 0 ? 'hidden' : ''}>
                                <Personal
                                    personalInfo={personalInfo}
                                    setPersonalInfo={setPersonalInfo}
                                    currentAddress={currentAddress}
                                    setCurrentAddress={setCurrentAddress}
                                    homeTownAddress={homeTownAddress}
                                    setHomeTownAddress={setHomeTownAddress}
                                    sameAddCheckBox = {sameAddCheckBox}
                                    employeeRecord={employeeRecord}
                                    handlePersonalInfoChange={handlePersonalInfoChange}
                                    handleCurrentAddressChange={handleCurrentAddressChange}
                                    handleHomeTownAddressChange={handleHomeTownAddressChange}
                                    validError={validError}
                                    setValidError={setValidError}
                                    checkSubmit={checkSubmit}
                                />
                            </div>
                            <div className={tabValue !== 1 ? 'hidden' : ''}>
                                <Organization
                                    validError={validError}
                                    setValidError={setValidError}
                                    checkSubmit={checkSubmit}
                                    employeeRecord={employeeRecord}
                                    setEmployeeRecord={setEmployeeRecord}
                                    passportInfo={passportInfo}
                                    setPassportInfo={setPassportInfo}
                                    familyInfo={familyInfo}
                                    setFamilyInfo={setFamilyInfo}
                                    emergencyContact={emergencyContact}
                                    legelNominee={legelNominee}
                                    bankInfo={bankInfo}
                                    handleEmployeeRecordChange={handleEmployeeRecordChange}
                                    handlePassPortInfoChange={handlePassPortInfoChange}
                                    handleFamilyInfoChange={handleFamilyInfoChange}
                                    handleEmergencyContactChange={handleEmergencyContactChange}
                                    handleLegalNomineeChange={handleLegalNomineeChange}
                                    handleBankInfoChange={handleBankInfoChange}
                                    handleDocumentChange={handleDocumentChange}
                                    document={document}
                                    documentString={documentString}
                                    setDocument={setDocument}
                                />
                            </div>
                            <div className={tabValue !== 2 ? 'hidden' : ''}><Documents personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg} /></div>
                            {params.id && <div className={tabValue !== 5 ? 'hidden' : 'h-full'}><Attendance /></div>}
                            {params.id && <div className={tabValue !== 6 ? 'hidden' : 'h-full'}><Asset /></div>}
                            <div className={tabValue !== 8 ? 'hidden' : ''}><TrainingEduction personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg} /></div>
                        </div>
                    </div>
                }
                leftSidebarContent={
                    <div className="px-16 py-24">
                        <div className="flex items-center justify-center mb-24">
                            <Avatar
                                sx={{
                                    backgroundColor: 'background.paper',
                                    color: 'text.secondary',
                                }}
                                className="avatar text-32 font-bold w-96 h-96"
                            // src={user.data.photoURL}
                            // alt={user.data.displayName}
                            >
                                {/* {user.data.displayName.charAt(0)} */}
                            </Avatar>
                        </div>
                        <div className='text-center mb-48'>
                            <Typography>
                                {`${personalInfo.empFirstName} ${personalInfo.empMiddleName} ${personalInfo.empLastName}`}
                            </Typography>
                            <Typography>
                                {employeeRecord.designation}
                            </Typography>
                            <Typography className='mb-16'>
                                {"Nolte FZE Dubai Silicon Oasis"}
                            </Typography>
                            <Typography color="text.secondary">
                                {currentAddress.mobile}
                            </Typography>
                            <Typography color="text.secondary">
                                {homeTownAddress.mobile}
                            </Typography>
                            <Typography color="text.secondary">
                                {personalInfo.email}
                            </Typography>

                        </div>
                        <FuseNavigation
                            className={clsx('navigation')}
                            navigation={TrainerNavigation.children}
                        />
                    </div>
                }
                leftSidebarOpen={leftSidebarOpen}
                leftSidebarWidth={288}
                leftSidebarOnClose={() => setLeftSidebarOpen(false)}
                scroll={'content'}
            />
        </div>
    )
}

export default TrainersForm